// extracted by mini-css-extract-plugin
export default {"info":"Details_info__iP3un","label":"Details_label__6ZySn","materials":"Details_materials__cB-aS","datepicker":"Details_datepicker__y82rU"};